    // Resize delay
    var windowWidth = $(window).width();
    $(window).on('resize', function () {
        var newWindowWidth = $(window).width();

        if (windowWidth !== newWindowWidth) {
            if (this.resizeTO) {
                clearTimeout(this.resizeTO);
            }
            this.resizeTO = setTimeout(function () {
                $(this).trigger($.Event('resizeEnd'));
            }, 200);
        }
        windowWidth = newWindowWidth;
    });